// The exported code uses Tailwind CSS. Install Tailwind CSS in your dev environment to ensure all styles work.
import React, { useEffect } from 'react';
import CommonHeader from './common/component/CommonHeader';
import AssetStatusCard from './domain/assetReport/component/AssetStatusCard';
import CompareAssetCard from './domain/assetReport/component/CompareAssetCard';
import InvestmentPerformanceCard from './domain/assetReport/component/InvestmentPerformanceCard';
import YearSettlementModal from './domain/assetReport/component/popup/YearSettlementModal';
import {
  useAppStateAssetGoalsListStore,
  useAppStateAssetPortfolioListStore,
  useAppStateAssetReportListStore,
  useAppStateCurrentAssetReportStore,
  useAppStateInvestmentIncomeListStore,
  useAppStatePrevAssetReportStore,
} from './common/store/AppStateStore.zustand';
import { useAssetReportAPI } from './domain/assetReport/api/AssetReport.api';
import CommonTitle from './common/component/CommonTitle';
import AssetGoalsCard from './domain/assetGoals/component/AssetGoalsCard';
import { useAssetGoalsAPI } from './domain/assetGoals/api/AssetGoals.api';
import AssetPortfolioCard from './domain/assetPortfolio/component/AssetPortfolioCard';
import { useAssetPortfolioAPI } from './domain/assetPortfolio/api/AssetPortfolio.api';
import ApartmentCompareCard from './domain/apartmentCompare/component/ApartmentCompareCard';
import { useApartmentCompareAPI } from './domain/apartmentCompare/api/ApartmentCompare.api';
import { useAppStateApartmentCompareListStore } from './common/store/AppStateStore.zustand';
import CommonFooter from './common/component/CommonFooter';
import FirstVisitWarning from './common/component/FirstVisitWarning';
import { LOCALFORAGE_YN } from './common/comstant/CommonConstants';
import { useInvestmentIncomeAPI } from './domain/investmentIncome/api/InvestmentIncome.api';

const App: React.FC = () => {
  const { getAssetReportList } = useAssetReportAPI();
  const { getAssetGoalsList } = useAssetGoalsAPI();
  const { getAssetPortfolioList } = useAssetPortfolioAPI();
  const { getApartmentCompareList } = useApartmentCompareAPI();
  const { getInvestmentIncomeList } = useInvestmentIncomeAPI();
  const { setAssetReportList } = useAppStateAssetReportListStore();
  const { setCurrentAssetReport } = useAppStateCurrentAssetReportStore();
  const { setPrevAssetReport } = useAppStatePrevAssetReportStore();
  const { setAssetGoalsList } = useAppStateAssetGoalsListStore();
  const { setAssetPortfolioList } = useAppStateAssetPortfolioListStore();
  const { setApartmentCompareList } = useAppStateApartmentCompareListStore();
  const { setInvestmentIncomeList } = useAppStateInvestmentIncomeListStore();

  useEffect(() => {
    initApp();
  }, []);

  const initApp = async () => {
    const { data: assetReportListResponse } = await getAssetReportList();
    const { data: assetGoalsListResponse } = await getAssetGoalsList();
    const { data: assetPortfolioListResponse } = await getAssetPortfolioList();
    const { data: apartmentCompareListResponse } = await getApartmentCompareList();

    if (assetReportListResponse) {
      setAssetReportList(assetReportListResponse);
      setCurrentAssetReport(assetReportListResponse.length > 0 ? assetReportListResponse[0] : undefined);
      setPrevAssetReport(assetReportListResponse.length > 1 ? assetReportListResponse[1] : undefined);
    }
    if (assetGoalsListResponse) {
      setAssetGoalsList(assetGoalsListResponse);
    }
    if (assetPortfolioListResponse) {
      setAssetPortfolioList(assetPortfolioListResponse);
    }
    if (apartmentCompareListResponse) {
      setApartmentCompareList(apartmentCompareListResponse);
    }
    try {
      const { data: investmentIncomeListResponse } = await getInvestmentIncomeList();
      if (investmentIncomeListResponse) {
        setInvestmentIncomeList(
          [...investmentIncomeListResponse].sort((a, b) => b.paymentDate.localeCompare(a.paymentDate)),
        );
      }
    } catch {
      // 기존 백엔드에 배당 내역 API가 없어도 새 자산 리포트 배당금은 계속 사용할 수 있다.
      setInvestmentIncomeList([]);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* 상단 메뉴 */}
      <CommonHeader />
      {/* 메인 콘텐츠 */}
      <main className="container mx-auto px-6 py-12">
        {/* 기준 년월 선택 */}
        <CommonTitle />
        {/* 카드 그리드 */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* 자산현황 카드 */}
          <AssetStatusCard />
          {/* 투자 성과 카드 */}
          <InvestmentPerformanceCard />
          {/* 전월 비교 카드 */}
          <CompareAssetCard />
          {/* 목표 관리 카드 */}
          <AssetGoalsCard />
          {/* 아파트 실거래가 비교 카드 */}
          <ApartmentCompareCard />
          {/* 포트폴리오 카드 */}
          <AssetPortfolioCard />
        </div>
      </main>
      {/* 푸터 */}
      <CommonFooter />
      {LOCALFORAGE_YN && <FirstVisitWarning />}
      <YearSettlementModal />
    </div>
  );
};
export default App;
